import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../environments/environment";
import { ViewImageDialogComponent } from "../../dialog/view-image-dialog/components/view-image-dialog.component";

@Component({
  selector: "app-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"],
})
export class ImageComponent implements OnInit {
  private _image = "";

  get image(): string {
    return this._image;
  }

  @Input() set image(value: string) {
    if (value == null) {
      return;
    }
    if (value.startsWith("data:image/png")) {
      this.host = "";
    }
    if (value.startsWith("http")) {
      this.host = "";
    }
    this._image = value;
  }

  @Input() isAvatar = false;

  @Input() popupImage?: string;
  @Input() height = 64;
  @Input() showDialog = true;

  host: string;

  constructor(private modal: NgbModal) {
    this.host = environment.baseUrl;
  }

  ngOnInit(): void {}

  showImage(): void {
    if (!this.showDialog) {
      return;
    }
    const modal = this.modal.open(ViewImageDialogComponent, {
      centered: true,
      backdrop: "static",
    });
    const instance = modal.componentInstance as ViewImageDialogComponent;
    if (this.popupImage) {
      instance.image = this.popupImage;
    } else {
      instance.image = this.image ?? "";
    }
  }
}
